import { getCookie, setCookie } from '../../utils/cookie';

export const initializeBackToAdPopup = async () => {
  const { renderBackToAdPopup } = await import('../../back_to_ad_popup');
  const el = document.getElementById('header-user-back-to-ad-container');

  const userId = window.__header_user_id__ || '';
  const cookieName = 'activeAddForm' + userId;

  if (!el) {
    return;
  }

  // В куке unixtime (когда обновилась). Проверяем, если прошло полчаса с момента обновления куки, показываем попап
  const time = getCookie(cookieName);
  const HALF_OF_HOUR = 30 * 60000; // 30 минут
  // Время через 30 минут после выставленного в куке
  const afterHalfOfHour = +new Date() + HALF_OF_HOUR;

  const timeToShow = time && parseInt(time, 10) > 0 ? new Date() > new Date(parseInt(time, 10) + HALF_OF_HOUR) : false;

  if (timeToShow) {
    renderBackToAdPopup(el, {
      onClick: () => {
        // Больше не будем показывать всплывашку о брошенной ФП, никогда
        setCookie(cookieName, '-1', 0);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.location.replace((window as any).__header_add_object_link__);
      },
      onClose: () => {
        // Покажем всплывашку о брошенной ФП только через полчаса
        setCookie(cookieName, afterHalfOfHour + '');
      },
    });
  }
};
